// Which conversation the chat may show. While a conversation picked from
// history loads, the previous one must not render under the new id.
export function resolveConversationView<T extends { id: string }>({
  conversationId, conversation, errorCode, resetCodes,
}: {
  conversationId: string | null;
  conversation: T | null;
  errorCode: string | null;
  resetCodes: ReadonlySet<string>;
}): { current: T | null; loading: boolean; loadError: boolean } {
  if (!conversationId) return { current: null, loading: false, loadError: false };
  const current = conversation && conversation.id === conversationId ? conversation : null;
  const loadError = !current && !!errorCode && !resetCodes.has(errorCode);
  return { current, loading: !current && !loadError, loadError };
}
